import Text from "@CubeComponents/html/Text/Text";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import NoData from "@Assets/icons/svg/NoData.svg";
import { t } from "@i18n";

/**
 * Shown when this tab's model-property data was cleared from the shared
 * IndexedDB by another tab's Settings > Clear Cache (detected by
 * `useModelPropertiesWiped`). A full reload resets per-tab Redux and refetches
 * the now-empty stores, so we prompt the user to refresh instead of silently
 * rendering an empty / broken panel.
 */
const ModelDataClearedState = () => (
  <div className="flex h-full flex-col items-center justify-center gap-4 p-6 text-center">
    <img src={NoData} alt="" aria-hidden width={160} />
    <Text>{t("This file's cached data was cleared from another tab. Refresh to reload it.")}</Text>
    <ButtonComponent buttonType={BUTTON_TYPES.GRADIENT_BUTTON} onClick={() => window.location.reload()}>
      {t("Refresh")}
    </ButtonComponent>
  </div>
);

export default ModelDataClearedState;
